import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserWebAiChatsQueryVariables = Types.Exact<{
  loggedUserId: Types.Scalars['String']['input'];
  chat_type: Types.Scalars['String']['input'];
}>;


export type GetUserWebAiChatsQuery = { __typename?: 'query_root', ai_chats: Array<{ __typename?: 'ai_chats', id: any, doctrine_chat_id: string, partition_id?: string | null, organization_id?: any | null, created_at: any, starter_message?: string | null, doctrine_title?: string | null, last_message?: string | null, is_brief: boolean, user_id: string, workspace_id?: any | null, user?: { __typename?: 'users', id: string, first_name: string, last_name: string, role?: string | null, email: string, profile_photo?: string | null } | null, workspace?: { __typename?: 'workspaces', id: any, name: string, logo?: string | null } | null }> };


export const GetUserWebAiChatsDocument = gql`
    query getUserWebAiChats($loggedUserId: String!, $chat_type: String!) {
  ai_chats(
    where: {user_id: {_eq: $loggedUserId}, chat_type: {_eq: $chat_type}}
    order_by: {created_at: desc}
  ) {
    id
    doctrine_chat_id
    partition_id
    organization_id
    created_at
    starter_message
    doctrine_title
    last_message
    is_brief
    user_id
    user {
      id
      first_name
      last_name
      role
      email
      profile_photo
    }
    workspace_id
    workspace {
      id
      name
      logo
    }
  }
}
    `;

/**
 * __useGetUserWebAiChatsQuery__
 *
 * To run a query within a React component, call `useGetUserWebAiChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWebAiChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWebAiChatsQuery({
 *   variables: {
 *      loggedUserId: // value for 'loggedUserId'
 *      chat_type: // value for 'chat_type'
 *   },
 * });
 */
export function useGetUserWebAiChatsQuery(baseOptions: Apollo.QueryHookOptions<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables> & ({ variables: GetUserWebAiChatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables>(GetUserWebAiChatsDocument, options);
      }
export function useGetUserWebAiChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables>(GetUserWebAiChatsDocument, options);
        }
export function useGetUserWebAiChatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables>(GetUserWebAiChatsDocument, options);
        }
export type GetUserWebAiChatsQueryHookResult = ReturnType<typeof useGetUserWebAiChatsQuery>;
export type GetUserWebAiChatsLazyQueryHookResult = ReturnType<typeof useGetUserWebAiChatsLazyQuery>;
export type GetUserWebAiChatsSuspenseQueryHookResult = ReturnType<typeof useGetUserWebAiChatsSuspenseQuery>;
export type GetUserWebAiChatsQueryResult = Apollo.QueryResult<GetUserWebAiChatsQuery, GetUserWebAiChatsQueryVariables>;